import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    source: { type: String, default: "partners" }
  }

  connect() {
    this.timeout = null
    document.addEventListener("click", this._handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this._handleClickOutside)
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this._hideResults()
      return
    }

    this.timeout = setTimeout(() => {
      this._fetchCities(query)
    }, 250)
  }

  select(event) {
    event.preventDefault()
    const city = event.currentTarget.dataset.city
    this.inputTarget.value = city
    this._hideResults()
    // Dispatch change event so parent form controllers (partner-search, clubs-search) pick it up
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Called via search-mode:modeChanged event
  updateSource(event) {
    const mode = event.detail.mode
    this.sourceValue = mode === "club" ? "clubs" : "partners"
  }

  async _fetchCities(query) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("q", query)
    url.searchParams.set("source", this.sourceValue)

    try {
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) throw new Error("Server error")

      const cities = await response.json()
      this._renderResults(cities)
    } catch (error) {
      console.error("Error fetching cities:", error)
    }
  }

  _renderResults(cities) {
    if (cities.length === 0) {
      this._hideResults()
      return
    }

    this.resultsTarget.innerHTML = cities.map(city => `
      <div class="city-autocomplete__item"
           data-action="click->city-autocomplete#select"
           data-city="${city}">
        <i class="fa-solid fa-location-dot me-2 text-muted"></i>
        ${city}
      </div>
    `).join("")

    this.resultsTarget.classList.remove("d-none")
  }

  _hideResults() {
    this.resultsTarget.classList.add("d-none")
    this.resultsTarget.innerHTML = ""
  }

  _handleClickOutside = (event) => {
    if (!this.element.contains(event.target)) {
      this._hideResults()
    }
  }
}
